import { useAuthInit } from '@/features/auth/hooks/use-auth-init';
import { useWahaSocketBootstrap } from '@/shared/socket/use-waha-socket-bootstrap';

/**
 * Bootstraps authentication state before rendering protected routes.
 * Validates persisted tokens against the API on application load.
 */
export function AuthInitializer() {
  useAuthInit();
  useWahaSocketBootstrap();
  return null;
}
